import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Search from '@material-ui/icons/Search';
import { format } from 'date-fns';
import React from 'react';
import { Link } from 'react-router-dom';
import BeneficiarioApi from '../../api/BeneficiarioApi';
import { withAplicacao } from '../../contexts/AplicacaoContext';
import { withUsuario } from '../../contexts/UsuarioContext';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import MUIDataTable from 'mui-datatables';
import {
  Avatar,
  Fab,
  IconButton,
  Fade,
  Paper,
  Slide,
  FormControl,
  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import FilterBeneficiario from '../share/FilterBeneficiario';
import ToolbarBeneficiarioSelect from './ToolbarBeneficiarioSelect';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  avatar: {
    margin: theme.spacing(0.5),
    padding: theme.spacing(0.5),
  },
  container: {
    display: 'block',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 320,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
  searchIcon: {
    marginRight: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  typographyTituloPaper: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
    fontSize: 14
  },
});

class ArquivoAlteracao extends React.Component {
  beneficiarioApi = new BeneficiarioApi();

  state = {
    tipo: 3,
    carteiraSelected: '',
    nomeBeneficiarioSelected: '',
    fluxo: [],
    beneficiarioSelected: {},
    fetching: false,
    page: 0,
    rowsPerPage: 5,
    carenciasOpen: false,
    snackOpen: false,
    beneficiarios: [],
  }

  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.consultarBeneficiarios();
    this.setState({fetching: false});
  }

  consultarBeneficiarios = async () => {
    const beneficiarios = await this.props.getBeneficiarios();
    this.setState({beneficiarios: beneficiarios});
  }

  consultarBeneficiarioCaixa = async () => {
    const beneficiarios = await this.beneficiarioApi.consultarBeneficiarioCaixa(this.state.carteiraSelected);
    this.setState({fluxo: beneficiarios, fetching: false});
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleClick = async (event) => {
    event.preventDefault();
    this.setState({fluxo: [], fetching: true});
    await this.consultarBeneficiarioCaixa();
  };

  handleOpenSnackbar = () => {
    this.setState({ snackOpen: true });
  };

  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };
  handleClickToolBar = () => {
    this.setState({ fetching: true });
  }
  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({carteiraSelected: carteira,
      nomeBeneficiarioSelected: nome,
      gerarExcelDisabled: nome !== ''});
  }
  handleClickLimpar = () => {
    this.setState({carteiraSelected: '', nomeBeneficiarioSelected: ''});
  }
  onOperacaoFinalizada = async () => {
    await this.consultarBeneficiarioCaixa();
  }
  render () {
    const options = {
      customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
        <ToolbarBeneficiarioSelect
          selectedRows={selectedRows}
          displayData={displayData}
          setSelectedRows={setSelectedRows}
          handleClickToolBar={this.handleClickToolBar}
          onOperacaoFinalizada={this.onOperacaoFinalizada}
          tipoArquivo={this.state.tipo}
        />
      ),
      print: false,
      download: false,
      selectableRows: 'multiple',
      filterType: 'dropdown',
      rowsPerPageOptions: [10, 50, 100],
      rowsPerPage: 10,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>beneficiário(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Nome',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Matrícula TST',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Titularidade',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Parentesco',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Dta. Nascimento',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Sexo',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'Início Adesão',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Fim Adesão',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value !== null ? <Typography style={{fontSize: 12}}>{format(new Date(value), 'DD/MM/YYYY')}</Typography> : '-';
          },
        }
      },
      {
        name: 'Carteira Caixa',
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: 'codServidor',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'codTipoMensalidade',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqBeneficiario',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqDependente',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
      {
        name: 'seqDepRh',
        options: {
          display: 'excluded',
          filter: false,
        }
      },
    ];

    const { classes } = this.props;
    const { from, to, fluxo, fetching } = this.state;
    const path = this.props.previousPath;

    return (
      <React.Fragment>
        <Link to={path} className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Alteração de Beneficiários Caixa Saúde</Typography>
              <Avatar className={classes.avatar}>{fluxo.length}</Avatar>
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            {this.state.beneficiarios.length !== 0 &&
            <FormControl component='fieldset' className={classes.marginLeft}>
              <FilterBeneficiario
                beneficiarios={this.state.beneficiarios}
                handleSelectBeneficiario={this.handleSelectBeneficiario}
                handleClickLimpar={this.handleClickLimpar} />
            </FormControl>
            }
            <Fab
              variant='extended'
              aria-label='Consultar'
              type='submit'
              onTouchStart={this.handleClick}
              onClick={this.handleClick}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Fab>
          </form>
        </Paper>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={fluxo}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
      </React.Fragment>
    );
  }
}

export default withUsuario(withAplicacao(withStyles(styles)(ArquivoAlteracao)));